'use client'

import { ReactNode } from 'react'
import { usePwaInstallAction } from '@/components/common/PwaInstallPrompt/pwaInstallContext'
import { useTranslation } from 'react-i18next'

type PwaInstallFooterLinkProps = {
  className?: string
  children?: ReactNode
}

export default function PwaInstallFooterLink({ className, children }: PwaInstallFooterLinkProps) {
  const { t } = useTranslation()
  const pwaInstall = usePwaInstallAction()

  if (!pwaInstall) {
    return null
  }

  return (
    <button
      type="button"
      onClick={pwaInstall.runInstall}
      className={className}
    >
      {children ?? t('common.install_app')}
    </button>
  )
}
